import { styled } from "@mui/styles"
import { TextField } from "@mui/material"
import { Autocomplete } from "@mui/material"
import assetPrefix from "@prefix"

const InputAutocompleteRenderInput = styled(({ ...rest }) => <TextField fullWidth={true} {...rest} />)(
  ({ theme, size, weight, bordercolor, borderradius, error, textalign, background }) => ({
    fontSize: size || "14px",
    fontWeight: weight || "300",
    padding: 0,
    borderRadius: borderradius || "2px",
    border: "solid 1px",
    borderColor: error ? theme.border.red : theme.border[bordercolor ? bordercolor : "gray_3"],
    background: theme.palette.background[background || "default"],
    "& .MuiAutocomplete-input": {
      padding: "2px 8px !important",
      fontSize: size || "14px",
      "&::placeholder": {
        fontSize: size || "14px"
      }
    },
    "& .MuiAutocomplete-inputRoot": {
      padding: "0 !important"
    },
    "& fieldset": {
      border: "none"
    },
    "& .MuiInputBase-input::placeholder": { color: theme.palette.text.primary },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.background.gray_2,
      WebkitTextFillColor: theme.palette.text.primary
    },
    "& input": { textAlign: textalign || "normal" },
    "& .MuiSvgIcon-root[data-testid='ArrowDropDownIcon']": {
      display: "none",
      top: "calc( 50% - 5px)",
      right: "10px",
      backgroundImage: `url(${assetPrefix}/images/bx-bxs-down-arrow@3x.png)`,
      width: "10px",
      height: "10px",
      backgroundPosition: "center",
      backgroundSize: "cover",
      transition: "all 0.3s"
    }
  })
)

const InputAutocomplete = ({ list, width, placeholder, ...rest }) => (
  <Autocomplete
    size="14px"
    weight="300"
    options={list}
    width={width || "100%"}
    sx={{ p: 0 }}
    renderInput={(params) => <InputAutocompleteRenderInput {...params} placeholder={placeholder} />}
    {...rest}
  />
)

export default InputAutocomplete
